import React, { memo } from 'react';
import { withRouter } from 'react-router-dom';

import Icon from 'components/Icon';

import { StyledFooter, Wrapper, Social } from './style';

const Footer = ({ location: { pathname } }) => {
	const isHome = pathname === '/';

	return (
		isHome && (
			<StyledFooter>
				<Wrapper>
					<p>تمامی حقوق مادی و معنوی این سایت متعلق به ناهارتایم است.</p>
					<Social>
						<a
							href='https://www.instagram.com/nahartime'
							target='_blank'
							rel='noopener noreferrer'
						>
							<Icon name='instagram' />
						</a>
						<a
							href='https://t.me/nahartime_com'
							rel='noopener noreferrer'
							target='_blank'
						>
							<Icon name='telegram' />
						</a>
						<a
							href='https://twitter.com/nahartime'
							rel='noopener noreferrer'
							target='_blank'
						>
							<Icon name='twitter' />
						</a>
						<a
							href='https://www.linkedin.com/company/nahartime'
							rel='noopener noreferrer'
							target='_blank'
						>
							<Icon name='linkedin' />
						</a>
					</Social>
				</Wrapper>
			</StyledFooter>
		)
	);
};

const areEqual = (prev, next) =>
	prev.location.pathname === next.location.pathname;

export default withRouter(memo(Footer, areEqual));
